module.exports = __webpack_public_path__ + "static/media/consulting.a225aa97.png";